import { IntersectionOptions, InViewHookResponse, useInView } from 'react-intersection-observer';
import isServer from '../utils/isServer';

const browserSupportsIntersectionObserver =
  !isServer() && typeof window.IntersectionObserver !== 'undefined';

const noop = () => {
  return;
};

// In theory, if we add a polyfills file to async load a polyfill in poorly supported browsers,
///canUseIntersection will just get checked so long as its not true to set up these properties.
function useIntersection(options: IntersectionOptions): InViewHookResponse {
  // This isn't hooks no-no because it will always return the same result given the same browser.
  if (isServer() || browserSupportsIntersectionObserver) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useInView(options);
  } else {
    return [noop, true, undefined] as InViewHookResponse;
  }
}

export default useIntersection;
